import { render, staticRenderFns } from "./CardDocumentation.vue?vue&type=template&id=20fdc50e&scoped=true&"
import script from "./CardDocumentation.vue?vue&type=script&lang=js&"
export * from "./CardDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./CardDocumentation.vue?vue&type=style&index=0&id=20fdc50e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fdc50e",
  null
  
)

export default component.exports